import {
	Card, LinkBox, LinkOverlay, Stack,
} from '@chakra-ui/react';
import type { Route } from 'next';
import React from 'react';
import {
	MdOutlineLocationOn,
	MdOutlineAccountBalanceWallet,
} from 'react-icons/md';

import { NextLinkWrapper } from '@/modules/navigation';
import {
	IconLabel, InterestedButton, NextImageWrapper,
	Image,
} from '@/modules/shared';

type JobCardFeaturedProps = {
	job: {
		id: string

		companyName: string
		detailUrl:   string
		image:       Image
		isSaved:     boolean
		location:    string
		salary:      string
		title:       string
	}

	onSelect:   () => void
	onUnselect: () => void
};

export const JobCardFeatured = ({ job, onSelect, onUnselect }: JobCardFeaturedProps) => {
	return (
		<LinkBox>
			<Card.Root p={0}>
				<Card.Header p={0}>
					<NextImageWrapper image={job.image} sizes="25vw" />
				</Card.Header>
				<Card.Body
					as={Stack}
					gap={3}
					px={4}
					py={2}
				>
					<Stack gap={0}>
						<LinkOverlay asChild>
							<NextLinkWrapper href={job.detailUrl as Route}>
								<Card.Title>
									{job.title}
								</Card.Title>
							</NextLinkWrapper>
						</LinkOverlay>
						<Card.Description>
							{job.companyName}
						</Card.Description>
					</Stack>
					<IconLabel
						icon={MdOutlineLocationOn}
						label={job.location}
						variant="featured"
					/>
					<IconLabel
						icon={MdOutlineAccountBalanceWallet}
						label={job.salary}
						variant="featured"
					/>
				</Card.Body>
				<Card.Footer p={4} pt={2}>
					<InterestedButton
						isSelected={job.isSaved}
						onSelect={onSelect}
						onUnselect={onUnselect}
						selectedLabel="Interested"
						size="sm"
						unselectedLabel="Interested"
						w="full"
					/>
				</Card.Footer>
			</Card.Root>
		</LinkBox>
	);
};
